// The one list of WHATIF social accounts, dropped into every site's footer.
//
// Self-contained on purpose: these six sites use four different styling systems (Tailwind,
// plain CSS classes, inline styles), so this carries its own inline styles and inherits
// nothing. Copy the file as-is when adding a new site; keep the LINKS array identical
// everywhere so a moved account is one edit per site, not a hunt through JSX.
//
// Every URL here was checked live before it shipped.
const LINKS = [
  ["X", "https://x.com/WHATIF_Rewards"],
  ["Facebook", "https://www.facebook.com/profile.php?id=61558433263890"],
  ["Instagram", "https://www.instagram.com/elyoyi420/"],
  ["Threads", "https://www.threads.net/@elyoyi420"],
  ["Bluesky", "https://bsky.app/profile/whatifrewards.bsky.social"],
  ["Telegram", "https://t.me/Rewards_in_WHATIF"],
  ["Discord", "https://discord.gg/R9CPWqnnp2"]
];

export default function SocialLinks({ heading = "Follow WHATIF Rewards", color = "#9aa0a6", hover = "#ffffff" }) {
  return (
    <div style={{ textAlign: "center", padding: "18px 12px" }}>
      {heading && (
        <div style={{ color, fontSize: "0.8em", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: "10px" }}>
          {heading}
        </div>
      )}
      <div style={{ display: "flex", justifyContent: "center", gap: "10px 18px", flexWrap: "wrap" }}>
        {LINKS.map(([name, href]) => (
          <a
            key={name}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`WHATIF Rewards on ${name}`}
            style={{ color, textDecoration: "none", fontSize: "0.92em", transition: "color .2s" }}
            onMouseOver={(e) => { e.currentTarget.style.color = hover; }}
            onMouseOut={(e) => { e.currentTarget.style.color = color; }}
          >
            {name}
          </a>
        ))}
      </div>
    </div>
  );
}
